import React from "react";
import shallowequal from "shallowequal";
import filter from "../../filter";
import {renderPrintFooter} from '../../utils';
import MarketReport from "../MarketReport";
import { reportTypes } from "../../consts/consts";
import { GET_TEXAS_MARKET_SHARE } from "../Graphql/Queries/propertiesQuery";
import { fetchData } from "../Service/graphQlService";

export default class MarketShareReport extends MarketReport {
    constructor(props) {
        super(props);
    }

    componentDidMount() {        
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`});
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
        this.fetch(this.props.location.query);
        window.history.replaceState(null, '');
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    fetch(q) {
        const query = {...q};

        const year = new Date().getFullYear();
        const optionsTexasSTNL = filter({...query, type: 'STNL'}, 'market-share');
        const optionsTexasMT = filter({...query, type: 'MT'}, 'market-share');        
        const optionsStriveSTNL = filter({...query, source:'STRIVE', type: 'STNL'}, 'market-share');
        const optionsStriveMT = filter({...query, source:'STRIVE', type: 'MT'}, 'market-share');
    
        const requests = [
            fetchData(GET_TEXAS_MARKET_SHARE, {options: optionsTexasSTNL.param}),
            fetchData( GET_TEXAS_MARKET_SHARE, {options: optionsStriveSTNL.param}),
            fetchData(GET_TEXAS_MARKET_SHARE, {options: optionsTexasMT.param}),
            fetchData(GET_TEXAS_MARKET_SHARE, {options: optionsStriveMT.param}),
        ];

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data && res[0].data.getTexasMarketShare &&
                res[1] && res[1].data && res[1].data.getTexasMarketShare &&
                res[2] && res[2].data && res[2].data.getTexasMarketShare &&
                res[3] && res[3].data && res[3].data.getTexasMarketShare) {

                const transactions = [];
                transactions.STNL = MarketReport.buildTableData({prevData: res[0].data.getTexasMarketShare, data: res[1].data.getTexasMarketShare, type: 'STNL'});
                transactions.MT = MarketReport.buildTableData({prevData: res[2].data.getTexasMarketShare, data: res[3].data.getTexasMarketShare, type: 'MT'});

                this.setState({
                    query,
                    year,
                    transactions
                });
                return;
            }

            this.setState({
                query,
                year
            });
        });
    }

    render() {
        const {query, transactions, year, isPrint, printBackground} = this.state;
        const reportType = reportTypes.MarketShare;

        return (
            <div className='MarketReport'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.MT, type: 'Multi-Tenant', market: query.market, year})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketReport.renderMarketTable({reportType:reportType, data: transactions.STNL, type: 'Single-Tenant', market: query.market, year})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
}